/** 顔アイコンを決めていない人に出すネコ */
export const DEFAULT_AVATAR = '/avatars/cat.svg'
